"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _SttBox = _interopRequireDefault(require("../../SttLayout/SttBox"));
var _SttText = _interopRequireDefault(require("../../SttTypography/SttText"));
var _SttMenuModulos = _interopRequireDefault(require("../../SttNavigation/SttMenuModulos"));
var _SmartphoneMenu = _interopRequireDefault(require("./SmartphoneMenu"));
var _SttNavigationBar = _interopRequireDefault(require("../../SttNavigation/SttNavigationBar"));
var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));
var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));
var _styles = require("@material-ui/core/styles");
var _reactResponsive = require("react-responsive");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    tituloModulo: _defineProperty({
      marginLeft: theme.spacing(2),
      color: theme.palette.background["default"],
      fontSize: '1.25rem',
      letterSpacing: '0.0125em',
      width: '33%'
    }, theme.breakpoints.down('sm'), {
      width: '100%'
    }),
    botaoSairModulo: {
      color: theme.palette.background.primary,
      cursor: 'pointer'
    },
    navigationBar: {
      width: '67%'
    },
    toolbar: {
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5)
    }
  };
});
var SttMainNavigationBar = function SttMainNavigationBar(props) {
  var classes = useStyles();
  var titulo = props.titulo,
    submenus = props.submenus,
    selectedTab = props.selectedTab,
    callbackNavigationBar = props.callbackNavigationBar,
    config = props.config,
    _props$mostrarMenuApl = props.mostrarMenuAplicativos,
    mostrarMenuAplicativos = _props$mostrarMenuApl === void 0 ? true : _props$mostrarMenuApl;

  /**Booleans que tratam se a interface é do tipo desktop, tablet ou mobile */
  var isDesktop = (0, _reactResponsive.useMediaQuery)({
    minWidth: 841
  });
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_SttBox["default"], null, /*#__PURE__*/_react["default"].createElement(_AppBar["default"], {
    position: "static"
  }, /*#__PURE__*/_react["default"].createElement(_Toolbar["default"], {
    className: classes.toolbar
  }, isDesktop && mostrarMenuAplicativos && /*#__PURE__*/_react["default"].createElement(_SttMenuModulos["default"], {
    config: config
  }), !isDesktop && submenus && /*#__PURE__*/_react["default"].createElement(_SmartphoneMenu["default"], {
    submenus: submenus
  }), /*#__PURE__*/_react["default"].createElement(_SttText["default"], {
    className: classes.tituloModulo
  }, titulo), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.navigationBar
  }, isDesktop && submenus && /*#__PURE__*/_react["default"].createElement(_SttNavigationBar["default"], {
    className: classes.navigationBar,
    submenus: submenus,
    selectedTab: selectedTab,
    callback: callbackNavigationBar
  }))))));
};
var _default = SttMainNavigationBar;
exports["default"] = _default;